interface PageBannerProps {
    image: string;
    title: string
}

export const PageBanner = ({ image, title }: PageBannerProps) => {
    return (
        <div className="relative w-full hidden md:block">
            {/* Image with overlay */}
            <div className="relative">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-auto"
                />

                {/* Text overlay - centered with shadow */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <h1 className="text-4xl md:text-5xl font-bold uppercase 
                                  text-white tracking-wider 
                                  drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                        {title}
                    </h1>
                </div>
            </div>
        </div>
    );
}